import embed from 'embed-video'

export default {
  props: {
    src: { type: String, required: true }
  },
  data: () => ({
    info: {}
  }),
  async created () {
    this.info = embed.info(this.src)
  },
  methods: {
    youtube (id) {
      return `https://www.youtube.com/embed/${id}?autoplay=1&disablekb=1&modestbranding=1&showinfo=0`
    },
    vimeo (id) {
      return `https://player.vimeo.com/video/${id}?autoplay=1&title=0&byline=0&portrait=0&color=F3094A`
    }
  },
  render (h) {
    return h('iframe', {
      attrs: {
        src: this[this.info.source](this.info.id),
        frameborder: 0,
        allow: 'autoplay; encrypted-media',
        allowfullscreen: true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/video-player.js